// extracted by mini-css-extract-plugin
module.exports = {"o-party-list":"PartyList_o-party-list__1oTLR"};